export default __webpack_public_path__ + "static/media/ImageArchitect2.960c2b9c.png";